import { Box, BoxProps } from '@mui/material';

import { OpacityAnimation } from './opacity-animation.component';

export interface ViewSectionProps {
  fullWidth?: boolean;
}

export const ViewSection = ({
  fullWidth,
  sx,
  children,
  ...props
}: BoxProps & ViewSectionProps) => {
  return (
    <Box
      component="section"
      {...props}
      sx={{
        width: '100%',
        maxWidth: fullWidth ? undefined : '100%',
        alignSelf: 'center',
        px: fullWidth ? 0 : 2,
        ...sx,
      }}
    >
      <OpacityAnimation>{children}</OpacityAnimation>
    </Box>
  );
};
